
export const monsterArray = [
    "Any",
    "Abberation",
    "Beast",
    "Celestial",
    "Construct",
    "Dragon",
    "Elemental",

    "Fey",
    "Fiend",
    "Fiend (demon)",
    "Fiend (devil)",
    "Fiend (shapechanger)",
    "Giant",
    "Humanoid",
    "Humanoid (any race)",
    "Humanoid (dwarf)",
    "Humanoid (elf)",
    "Humanoid (gnoll)",
    "Humanoid (gnome)",
    "Humanoid (goblinoid)",
    "Humanoid (grimlock)",
    "Humanoid (human)",
    "Humanoid (human, shapechanger)",
    "Humanoid (kobold)",
    "Humanoid (lizardfolk)",
    "Humanoid (merfolk)",
    "Humanoid (orc)",
    "Humanoid (sahuagin)",
    "Monstrosity",
    "Monstrosity (shapechanger)",
    "Monstrosity (titan)",
    "Ooze",
    "Plant",
    "Swarm of tiny beasts",
    "Undead",
    "Undead (shapechanger)",
  ];

  export const monsterSizeArray = [
    'Tiny',
  'Small',
  'Medium',
  'Large',
  'Huge',
  'Gargantuan'
  ]

  export const monsterAlignmentArray = [
    'Lawful good (LG) ',
  'Neutral good (NG) ',
  'Chaotic good (CG) ',
  'Lawful neutral (LN) ',
  'Neutral (N) ',
  'Chaotic neutral (CN)'
  ]

  export const race = [
      'Dragonborn',
      'Dwarf',
      'Elf',
      'Gnome',
      'Half-elf',
      'Half-orc',
      'Halfling',
      'Human',
      'Tiefling'
  ]

  export const isMobileSize = () => {
    if (window.screen.width <= 768) {
      return true;
    } else {
      return false;
    }
  };